let API_URL = '';

fetch('/settings.json')
  .then(res => res.json())
  .then(data => {
    API_URL = data.ApiUrl || '';
  })
  .catch(err => console.error('Failed to load settings:', err));

export interface UserPreferences {
  alias?: string;
  teamNames: string[];
  /** Legacy single-team attribute kept on items saved before multi-team support. */
  teamName?: string;
  reminderMethod: string;
  phoneNumber: string;
  telegramChatId: string;
  remindersEnabled: boolean;
  remindersTime: number;
}

export const getPreferences = async (token: string): Promise<UserPreferences | null> => {
  if (!API_URL) {
    const settings = await fetch('/settings.json').then(r => r.json());
    API_URL = settings.ApiUrl || '';
  }
  
  try {
    const response = await fetch(`${API_URL}preferences`, {
      method: 'GET',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
      },
    });

    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);
    
    if (response.status === 404) {
      return null;
    }

    if (!response.ok) {
      const text = await response.text();
      console.error('Response error:', text);
      throw new Error('Failed to fetch preferences');
    }

    const data = await response.json();
    console.log('Response data:', data);
    return data;
  } catch (error) {
    console.error('Error fetching preferences:', error);
    return null;
  }
};

export const savePreferences = async (preferences: UserPreferences, token: string): Promise<boolean> => {
  if (!API_URL) {
    const settings = await fetch('/settings.json').then(r => r.json());
    API_URL = settings.ApiUrl || '';
  }
  
  console.log('Saving preferences:', preferences);
  console.log('API_URL:', API_URL);
  
  try {
    const response = await fetch(`${API_URL}preferences`, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(preferences),
    });

    console.log('Save response status:', response.status);
    return response.ok;
  } catch (error) {
    console.error('Error saving preferences:', error);
    return false;
  }
};

export const deletePreferences = async (token: string): Promise<boolean> => {
  if (!API_URL) {
    const settings = await fetch('/settings.json').then(r => r.json());
    API_URL = settings.ApiUrl || '';
  }
  
  try {
    const response = await fetch(`${API_URL}preferences`, {
      method: 'DELETE',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
      },
    });

    return response.ok;
  } catch (error) {
    console.error('Error deleting preferences:', error);
    return false;
  }
};
